<template>
  <div class="info-card" @click="goToShopDetailPage()">
    <div class="left">
      <img v-if="data.mainImage" :src="data.mainImage" alt="" />
      <div v-if="!data.mainImage" class="placeholder"></div>
    </div>
    <div class="right">
      <div class="name">{{ data.name }}</div>
      <div class="tagAndAddress">
        <span class="tag" v-for="(item, index) in categoryNames" :key="index">
          {{ item }}
        </span>
        <span class="distance">{{ distance }}</span>
        <span v-if="categoryNames.length" class="separator">|</span>
        <span class="address">{{ data.address.city || "" }}</span>
      </div>
      <div v-if="openingHours" class="openingHours">开放时间：{{ openingHours }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activityInfo: {
      default: null
    },
    userPosition: {
      default: null
    },
    data: {
      require: true,
      default: null
    }
  },
  computed: {
    categoryNames () {
      return [this.data.redTemplate.topCategory?.name]
    },
    distance () {
      if (this.data.distance < 0.1) {
        return '<100m'
      } else {
        return this.data.distance + 'km'
      }
    },
    openingHours () {
      return this.data.redTemplate.openingHours || ''
    }
  },
  methods: {
    goToShopDetailPage () {
      this.$router.push({
        path: '/detailPage',
        query: {
          shopId: this.data.id,
          id: this.data.activityId
        }
      })
    }
  },
  mounted () {
    // console.log("mounted", this.data, this.activityInfo.mapStyle.categories)
  }
}
</script>

<style scoped="scoped" lang="scss">
.info-card {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  position: relative;
  .left {
    padding: 0.2rem 0.2rem 0;
    display: flex;
    justify-content: center;
    .placeholder, img {
      width: 1.8rem;
      height: 1.8rem;
      display: inline-block;
      border-radius: 10px;
      object-fit: cover;
    }
    .placeholder {
      border: 1px solid #ccc;
      border-radius: 0px;
    }
  }
  .right {
    width: 4.9rem;
    position: relative;
    padding: 0.2rem 0.2rem 0 0;
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    overflow: hidden;
    .name {
      line-height: 0.42rem;
      padding-right: 0.72rem;
      font-size: 0.34rem;
      color: #333333;
      letter-spacing: 0;
      margin-bottom: 0.15rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    .tagAndAddress {
      height: auto;
      margin-bottom: 0.15rem;
      font-size: 0.26rem;
      color: #666666;
      display: flex;
      align-items: center;
      .tag {
        display: inline-block;
        margin-right: 0.1rem;
        background: #ffdba0;
        color: #7e2e15;
        font-size: 12px;
        height: 0.35rem;
        padding: 0 0.1rem;
        text-align: center;
        line-height: 0.36rem;
        border-radius: 4px;
      }
      .distance {
        margin-right: 0.1rem;
      }
      .separator {
        margin-right: 0.1rem;
      }
    }
    .openingHours {
      font-size: 0.26rem;
      color: #666666;
    }
  }
}
</style>
